const reviews = document.querySelectorAll<HTMLElement>('.pd-reviews')

reviews.forEach(review => {
  const loadMore = review.querySelector<HTMLElement>('.pd-reviews__link')

  loadMore?.addEventListener('click', (e) => {
    e.preventDefault();
    const title = loadMore.querySelector<HTMLElement>('.link__title');
    loadMore.classList.toggle('--open');
    review.classList.toggle('--open');

    const alternativeTitle = loadMore.dataset.alternativeTitle;
    if(!alternativeTitle) return;

    const tempTitle = title.innerText;
    title.innerText = alternativeTitle;
    loadMore.dataset.alternativeTitle = tempTitle;
  })
})
